import { put, call, takeEvery } from "redux-saga/effects";
import { claimPendingList } from "../../Services/ClaimCashless";
import { mutate } from "swr";

export function* claimPendingListSaga(action) {
  const { payload } = action;
  try {
    const res = yield call(claimPendingList, payload.data);
    yield put({ type: "REQ_CLAIM_LIST_PENDING_SUCCESS", data: res.data });
    yield call(mutate, "claimListKey", res.data, false);
  } catch (e) {
    yield put({ type: "REQ_CLAIM_LIST_PENDING_FAILED", errData: e });
    yield call(mutate, "claimListKey", [], false);
  }
}

export function* claimListNotifSaga() {
  yield takeEvery("REQ_CLAIM_PENDING_LIST", claimPendingListSaga);
}
